var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(0 0.638672)",
    fill: "url(#paint0_linear_935_1777)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6165 25.2645C15.6416 25.2791 15.6614 25.2904 15.6754 25.2983L15.6987 25.3112C15.8844 25.4132 16.1148 25.4124 16.3007 25.3116L16.3246 25.2983C16.3386 25.2904 16.3584 25.2791 16.3835 25.2645C16.4339 25.2354 16.5058 25.1928 16.5963 25.1372C16.7771 25.0258 17.0323 24.8616 17.3372 24.6463C17.9459 24.2162 18.7581 23.5782 19.5721 22.7448C21.1922 21.086 22.875 18.5938 22.875 15.3887C22.875 11.5917 19.797 8.51367 16 8.51367C12.203 8.51367 9.125 11.5917 9.125 15.3887C9.125 18.5938 10.8078 21.086 12.4279 22.7448C13.2419 23.5782 14.0541 24.2162 14.6628 24.6463C14.9677 24.8616 15.2229 25.0258 15.4037 25.1372C15.4942 25.1928 15.5661 25.2354 15.6165 25.2645ZM16 17.8887C17.3807 17.8887 18.5 16.7694 18.5 15.3887C18.5 14.008 17.3807 12.8887 16 12.8887C14.6193 12.8887 13.5 14.008 13.5 15.3887C13.5 16.7694 14.6193 17.8887 16 17.8887Z",
    fill: "#F8F9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_935_1777",
    x1: -2.26046e-7,
    y1: 29.1589,
    x2: 32.5836,
    y2: 27.0708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLocation);
export default __webpack_public_path__ + "static/media/footer-location.00bd0f75b210e14c48f041d0cfff917c.svg";
export { ForwardRef as ReactComponent };